import React from "react";
import { PieChart } from "@mui/x-charts";
import { Box, Card, CardContent, Typography, useTheme } from "@mui/material";

interface DataPoint {
  id: string;
  value: number;
  label: string;
}

interface AnalyticsPieProps {
  data: DataPoint[];
  title: string;
}

const AnalyticsPie: React.FC<AnalyticsPieProps> = ({ data, title }) => {
  const theme = useTheme();

  return (
    <Card>
      <CardContent>
        <Typography
          variant="h6"
          gutterBottom
          color={theme.palette.primary.main}
        >
          {title}
        </Typography>
        <Box display="flex" justifyContent="center" alignItems="center">
          <PieChart
            series={[
              {
                data: data,
                innerRadius: 70,
                outerRadius: 100,
                paddingAngle: 1,
                cornerRadius: 0,
                startAngle: -150,
                endAngle: 225,
              },
            ]}
            colors={[
              "#6B20F5", // main
              "#7A2BFF", // 15% more white
              "#8B3CFF", // 30% more white
              "#9C4DFF", // 45% more white
              "#AD5EFF", // 60% more white
            ]}
            width={350}
            height={350}
          />
        </Box>
      </CardContent>
    </Card>
  );
};

export default AnalyticsPie;
